import React, { FC, PropsWithChildren } from 'react';
import { ConfigProvider as AntdConfigProvider } from 'antd';

import { antdConfig } from '@/config';
import { usePersonalizationStore } from '@/store/personalization';

const ConfigProvider: FC<PropsWithChildren> = ({ children }) => {
  const themeColor = usePersonalizationStore(s => s.themeColor);
  const config = themeColor
    ? { ...antdConfig, theme: { ...antdConfig.theme, token: { ...antdConfig.theme?.token, colorPrimary: themeColor } } }
    : antdConfig;
  return <AntdConfigProvider {...config}>{children}</AntdConfigProvider>;
};

export default ConfigProvider;
